// How we got here — the discipline story: how many deals we looked at against
// how many we took forward, and why we passed on the rest.
//
// The counts are pipelineFunnel's, fed the same stage history the Pipeline tab
// feeds it, so this and Pipeline cannot disagree. There were once two funnels in
// the app (622 → 160 → 64 → 2 against 201 → 62 → 9 → 1); Pipeline's is the one
// the team stands behind, so it is the only one drawn.
const LABEL = {
  Screening: "Screened",
  Underwriting: "Underwritten",
  "LOI Submitted": "LOI submitted",
  "In Diligence": "In diligence",
};

function joinReasons(rs) {
  const parts = rs.map((r, i) => (
    <span key={r.reason}>
      <b className="font-semibold text-[#f4f4f4]">{r.reason}</b> ({r.n}){i < rs.length - 2 ? ", " : i === rs.length - 2 ? " and " : ""}
    </span>
  ));
  return parts;
}

export default function HomeFunnel({ funnel, reasons }) {
  const steps = funnel.stages;
  const top = steps.length ? steps[0].count : 0;
  return (
    <section data-print-block className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <h3 className="text-[15px] font-semibold text-[#f4f4f4]">How we got here</h3>
      <p className="mt-0.5 text-[12px] text-[#8a8a8a]">Every deal in the pipeline, by the furthest stage it reached</p>

      <div className="mt-4">
        {steps.map((s, i) => {
          const last = i === steps.length - 1;
          const next = steps[i + 1];
          return (
            <div key={s.label}>
              <div className="grid grid-cols-[110px_1fr_56px] items-center gap-3">
                <div className="text-[12.5px] text-[#b4b4b4]">{LABEL[s.label] || s.label}</div>
                <div>
                  <div className="h-[22px] min-w-[3px] rounded-r"
                    style={{ width: `${top ? Math.max((s.count / top) * 100, 0.6) : 0}%`, background: last ? "#e93529" : "#5c5c5c" }} />
                </div>
                <div className="text-right text-[14px] font-semibold text-[#f4f4f4]">{s.count}</div>
              </div>
              {next && (
                <div className="my-[3px] ml-[122px] flex h-4 items-center gap-1.5 text-[10.5px] text-[#8a8a8a]">
                  <span className="inline-block h-3 w-px bg-[#3a3a3a]" />
                  {s.count ? `${Math.round((next.count / s.count) * 100)}% continue` : ""}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {reasons.length > 0 && (
        <p className="mt-4 border-t border-[#303030] pt-3.5 text-[12.5px] leading-relaxed text-[#b4b4b4]">
          What we passed on most: {joinReasons(reasons)}.
        </p>
      )}
    </section>
  );
}
